<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.53033 1.20142C7.23744 0.90812 6.76256 0.90812 6.46967 1.20142L0.21967 7.46009C-0.0732234 7.75339 -0.0732234 8.22892 0.219669 8.52222L6.46967 14.7809C6.76256 15.0742 7.23744 15.0742 7.53033 14.7809C7.82322 14.4876 7.82322 14.0121 7.53033 13.7188L1.81066 7.99115L7.53033 2.26355C7.82322 1.97025 7.82322 1.49472 7.53033 1.20142Z"
  />
</template>
